const conferenceService = {
	createGoogleMeet: async (tokens, eventTitle = "New Meeting") => {
		if (!tokens || !tokens.access_token) {
			throw new Error("Valid authentication tokens are required");
		}

		try {
			const response = await fetch(
				"https://api.my-cron.com/api/conference/google-meet",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						tokens, // Send the entire tokens object
						title: eventTitle,
					}),
					credentials: "include", // Add this if you're using cookies
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.error || "Failed to create Google Meet");
			}

			const data = await response.json();

			return {
				type: "gmeet",
				url: data.meetingUrl,
				id: data.meetingId,
			};
		} catch (error) {
			console.error("Google Meet creation failed:", error);
			throw error;
		}
	},
};

export default conferenceService;
